import DashboardNewMeasurementView from 'components/views/DashboardNewMeasurementView';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { bindActionCreators } from 'redux';
import { actionCreators as dashboardAC } from 'store/dashboard';
import { actionCreators as eventsAC } from 'store/events';
import { actionCreators as layoutAC } from 'store/layout';
import { getIsAuthenticated } from 'store/login';
import { getCoach, getHasUserBeenLoaded, getUserData, getWeight } from 'store/profile';
import { actionCreators as trackingAC } from 'store/trackingDescription';
import { HistoryType, MatchType } from 'types/withRouter';

export type FavoritesDetailViewContainerProps = {
	history: HistoryType;
	match: MatchType & {
		params: {
			type: string;
			id: string;
		};
	};
};

export const mapStateToProps = (state) => {
	return {
		coach: getCoach(state),
		currentWeight: getWeight(state),
		isAuthenticated: getIsAuthenticated(state),
		isUserLoaded: getHasUserBeenLoaded(state),
		userData: getUserData(state),
	};
};

export const mapDispatchToProps = (dispatch) => {
	return bindActionCreators(
		{
			doRequestMeasurement: dashboardAC.doRequestMeasurement,
			doAddEvents: eventsAC.doAddEvents,

			doLockBody: layoutAC.doLockBody,

			doOpenDescription: trackingAC.doOpenDescription,
		},
		dispatch
	);
};
const connector = connect(mapStateToProps, mapDispatchToProps);

export default withRouter((connector as any)(DashboardNewMeasurementView));
